import { isValidPhoneNumber } from 'react-phone-number-input';
import isEmail from 'validator/lib/isEmail';
import isURL from 'validator/lib/isURL';

import { LATIN_ALPHABET_REG_EX } from 'constants/constants';
import { ApplicationEnvironments } from 'enums/common.enums';

export const getMessageForRequiredFields = (fieldName: string = 'This information') => {
  return `${fieldName} is required`;
};

export const getMessageForInvalidFields = (fieldName: string = 'This information') => {
  return `${fieldName} is invalid`;
};

export const isValidEmail = (email: string) => {
  return isEmail(email);
};

export const getPatterns = () => {
  return {
    phone: /\+1[0-9]{10}$/g,
    zip: /^\d{5}$|\d{5}-\d{4}/,
    url: /(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/,
  };
};

const checkPhoneNumberIsProveTestCase = (value: string) => {
  const proveTestPhoneNumberRegExp = /^\+1200100\d{4}$/;

  return proveTestPhoneNumberRegExp.test(value);
};

export const validatePhoneNumber = (value: string) => {
  // exception to allow phone numbers starting with (350) area code in California state
  const phoneNumberRegExpException = /^\+1350\d{7}$/;
  const errorMessage = 'Not a valid US phone number';

  if (!value) {
    return errorMessage;
  }

  if (
    process.env.REACT_APP_ENVIRONMENT !== ApplicationEnvironments.Production &&
    checkPhoneNumberIsProveTestCase(value)
  ) {
    return true;
  }

  if (isValidPhoneNumber(value, 'US') || phoneNumberRegExpException.test(value)) {
    return true;
  }

  return errorMessage;
};

export const isValidUrl = (url: string) => {
  return isURL(url);
};

export type Dictionary<T> = {
  [Key: string]: T;
};

interface ValidatorParam {
  value: string | boolean;
  pattern?: RegExp;
  isRequired: boolean;
}

export const validator = {
  isValid: (params: Dictionary<ValidatorParam>) => {
    return Object.keys(params).every((paramKey) => {
      const param = params[paramKey];

      if (param.pattern && param.value && param.isRequired) {
        return param.pattern.test(param.value?.toString());
      }

      if (!param.isRequired && param.pattern) {
        return param.value ? param.pattern.test(param.value?.toString()) : true;
      }

      if (!param.isRequired) {
        return true;
      }

      return !!param.value;
    });
  },
};

export const isOnlyLatinAlphabet = (input?: string): boolean => !!input && LATIN_ALPHABET_REG_EX.test(input);

export const isValidYearsOfBusiness = (input: string) =>
  (!!input && +input >= 0 && +input <= 100) || 'Allowed range from 0 to 100';
